import PropTypes from 'prop-types';
import { useMutation, useQuery } from '@apollo/client';
import { Dialog, DialogTitle } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { MERGE_PROPERTY_ITEMS } from '../../graphql/mutation/collectionTypePropertyListItems';
import { GET_COLLECTION_TYPE_PROPERTY_BY_SLUG } from '../../graphql/query/collectionTypeProperties';

import ReplaceCollectionTypePropertyItemForm from '../replace-collection-type-property-item-form';

const ReplaceCollectionTypePropertyItemModal = (props) => {
  const { onClose, updateItems, initReplacingItem, ...modalProps } = props;
  const params = useParams();

  // eslint-disable-next-line react/destructuring-assignment
  const slug = params.slug || props.slug;

  const { data } = useQuery(GET_COLLECTION_TYPE_PROPERTY_BY_SLUG, { variables: { slug } });
  const propertyData = data?.collectionTypePropertyBySlug || {};
  const propertyName = propertyData?.name;
  const propertyDescription = propertyData?.description;
  const propertyTitle = `${propertyName} (${propertyDescription})`;

  const [mergePropertyItems, { loading, error }] = useMutation(MERGE_PROPERTY_ITEMS, {
    onCompleted,
  });

  const initialValues = {
    replacing: initReplacingItem || {},
    target: {},
  };

  function onCompleted() {
    if (updateItems) updateItems();
    onClose();
  }

  function onSubmit(variables) {
    mergePropertyItems({ variables });
  }

  const renderForm = propertyData && (
    <ReplaceCollectionTypePropertyItemForm
      property={propertyData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      loading={loading}
      error={error}
      onClose={onClose}
    />
  );

  return (
    <Dialog onClose={onClose} {...modalProps}>
      <DialogTitle>Replace {propertyTitle} item</DialogTitle>
      {renderForm}
    </Dialog>
  );
};

ReplaceCollectionTypePropertyItemModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  updateItems: PropTypes.func,
  initReplacingItem: PropTypes.object,
  slug: PropTypes.string,
};

ReplaceCollectionTypePropertyItemModal.defaultProps = {
  updateItems: () => {},
  initReplacingItem: null,
  slug: null,
};

export default ReplaceCollectionTypePropertyItemModal;
